import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-skeleton-torito-row',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-torito-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonToritoRowComponent {
  nItem = input<number>(1);
  rowItem = computed(() => Array.from({ length: this.nItem() }, (_, i) => i));
  nSubItem = Array.from({ length: this.getRandomNumber(3) }, (_, i) => i);

  items = Array.from({ length: 3 }, (_, i) => i);

  getRandomNumber(max: number, min: number = 1) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
